module.exports = require("./ks.d.ts");